module.exports = __webpack_public_path__ + "static/img/boss.00d99ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/boss.png
// module id = 7Tnx
// module chunks = 2